export default {
      id: "circle-red-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svgsprite.svg#circle-red",
      toString: function () {
        return this.url;
      }
    }